enum ColorEnum {
    'Primary' = 'primary',
    'Secondary' = 'secondary',
    'PrimaryFilled' = 'primaryFilled',
}

export default ColorEnum;
